
// Generated from  MetaManagement.cs

import {ApiRequestAsync} from "./ApiRequest";
import {Promise} from 'es6-promise';
import {InputType,InputText,InputNumber,InputBoolean,InputChoice,InputFile,InputDate,PrivilegeMembership,FileNote,LanguageInfo,RemoveQuery,FilterMode,ValueCaptionPair} from "./Shared";


export function getMetaAsync(query : MetaDetailsQuery): Promise<MetaDetails> {
  return ApiRequestAsync<MetaDetails>('IMetaManagementApi', 'GetMetaAsync', query);
}

export function insertOrUpdateMetaAsync(details : MetaDetailsUpdate): Promise<MetaDetails> {
  return ApiRequestAsync<MetaDetails>('IMetaManagementApi', 'InsertOrUpdateMetaAsync', details);
}

export function removeMetaAsync(query : RemoveQuery): Promise<void> {
  return ApiRequestAsync<void>('IMetaManagementApi', 'RemoveMetaAsync', query);
}

export function reorderMetasAsync(guids : string[]): Promise<MetaInfo[]> {
  return ApiRequestAsync<MetaInfo[]>('IMetaManagementApi', 'ReorderMetasAsync', guids);
}

export function queryMetasAsync(searchTerm : string): Promise<MetaInfo[]> {
  return ApiRequestAsync<MetaInfo[]>('IMetaManagementApi', 'QueryMetasAsync', searchTerm);
}




import {observable, IObservableArray} from "mobx";

 
export class MetaInfo {     
	@observable guid: string = "";    
	@observable caption: string = "";    
	@observable captionNeedsTranslation: boolean;    
	@observable isGlobal: boolean;
}
 
export class MetaDetailsQuery {     
	guid: string = "";    
	language: string = "";
}
 
export class MetaDetails {     
	@observable guid: string = "";    
	@observable id: InputText = new InputText();
	@observable iirdsId: InputText = new InputText();    
	@observable regex: InputText = new InputText();    
	@observable caption: InputText = new InputText();    
	@observable languageDependent: InputBoolean = new InputBoolean();    
	@observable multiple: InputBoolean = new InputBoolean();    
	@observable predefined: InputBoolean = new InputBoolean();    
	@observable dataType: InputChoice = new InputChoice();    
	@observable required: InputBoolean = new InputBoolean();    
	@observable showAsColumn: InputBoolean = new InputBoolean();    
	metaValues: IObservableArray<MetaValue> = observable.array([]);    
	@observable showAsFilter: InputBoolean = new InputBoolean();    
	@observable filterMode: InputChoice = new InputChoice();    
	@observable filterMaxValues: InputNumber = new InputNumber();    
	@observable showAsInfo: InputBoolean = new InputBoolean();    
	@observable lastModified: Date;    
	@observable captionLastModified: Date;    
	@observable isValid: boolean;    
	@observable validationMessage: string = "";    
	@observable isGlobal: boolean;
}
 
export class MetaDetailsUpdate {     
	guid: string = "";    
	language: string = "";    
	id: string = "";
	iirdsId: string = "";    
	regex: string = "";    
	caption: string = "";    
	captionNeedsTranslation: boolean;    
	languageDependent: boolean;    
	multiple: boolean;    
	predefined: boolean;    
	dataType: string = "";    
	required: boolean;    
	showAsColumn: boolean;    
	metaValues: MetaValueUpdate[] = [];    
	showAsFilter: boolean;    
	filterMode: FilterMode;    
	filterMaxValues: number;    
	showAsInfo: boolean;    
	lastModified: Date;    
	captionLastModified: Date;
}
 
export class MetaValue {     
	@observable guid: string = "";    
	@observable parentId: string = "";    
	@observable value: InputText = new InputText();    
	@observable canDelete: boolean;    
	@observable lastModified: Date;    
	@observable languageLastModified: Date;
}
 
export class MetaValueUpdate {     
	guid: string = "";    
	parentId: string = "";    
	value: string = "";    
	valueNeedsTranslation: boolean;    
	lastModified: Date;    
	languageLastModified: Date;
}



export function _ignoreCompilerError_TS6133(x: any) : boolean {
  return (x instanceof InputText) || 
		 (x instanceof InputBoolean) || 
		 (x instanceof InputChoice) || 
		 (x instanceof InputDate) ||
		 (x instanceof InputFile) || 
		 (x instanceof PrivilegeMembership) || 
		 (x instanceof FileNote) || 
		 (x instanceof LanguageInfo) || 
		 (x instanceof RemoveQuery);
}

